export default __webpack_public_path__ + "static/8-3ab646e1dacb2f87ee148f8cbc6aac8e.jpg";